<template>
    <div>
        <form @submit.prevent="validate">
            <div class="mb-3">
                <h5>Clinic Details</h5>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>General Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Clinic Name</label>
                            <input type="text" name="name" data-vv-validate-on="blur" data-vv-as="name"
                                placeholder="Clinic Name" v-model="value.name" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('name')
                            }">
                            <div v-show="validationErrors.has('name')" class="invalid-feedback">
                                {{ validationErrors.first('name') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Languages Speak</label>
                            <!-- <input type="text" name="languagesSpeak" data-vv-validate-on="blur" data-vv-as="languages speak" placeholder="Languages(s) Speak" v-model="value.languagesSpeak" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('languagesSpeak')
                            }"> -->
                            <!-- <small>Separate multiple languages by a comma (,)</small>
                            <div v-show="validationErrors.has('languagesSpeak')" class="invalid-feedback">
                                {{ validationErrors.first('languagesSpeak') }}
                            </div> -->
                            <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                            <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                                The languages speak field is required.
                            </div>
                            <div class="row">
                                <div class="col-6 not-required" v-for="language in languages" :key="language">
                                    <input type="checkbox" :id="language" :value="language" v-model="value.languagesSpeak">
                                    <label class="ml-2" :for="language">{{ language }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Internet Provider (Optional)</label>
                            <input type="text" name="internetProvider" data-vv-validate-on="blur" data-vv-as="internet provider"
                                placeholder="Internet Provider" v-model="value.internetProvider" v-validate="''" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('internetProvider')
                            }">
                            <div v-show="validationErrors.has('internetProvider')" class="invalid-feedback">
                                {{ validationErrors.first('internetProvider') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Clinic Registration (SSM) Number (Optional)</label>
                            <input type="text" name="clinicRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Clinic Registration (SSM) Number"
                                placeholder="Clinic Registration (SSM) Number (Optional)" v-model="value.clinicRegistrationNumber" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('clinicRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('clinicRegistrationNumber') }}
                            </div>
                        </div>

                        <div v-if="!!value.clinicRegistrationNumber" class="form-group">
                            <label>Clinic Registration (SSM) Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="ssmFileInput" type="file" v-validate="''" data-vv-as="Clinic Registration (SSM) Document" name="ssmFileInput" :class="{'is-invalid':  validationErrors.has('ssmFileInput')}">
                                    <div v-show="validationErrors.has('ssmFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('ssmFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="form-group">
                            <label>GST Registration Number (Optional)</label>
                            <input type="text" name="gstRegistrationNumber" data-vv-validate-on="blur" data-vv-as="GST registration number"
                                placeholder="GST Registration Number" v-model="value.gstRegistrationNumber" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('gstRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('gstRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('gstRegistrationNumber') }}
                            </div>
                        </div> -->

                        <div class="form-group">
                            <label>Borang B/F Number (Optional)</label>
                            <input type="text" name="borangbNumber" data-vv-validate-on="blur" data-vv-as="Borang B/F number"
                                placeholder="Borang B/F Number" v-model="value.borangbNumber" v-validate="''" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('borangbNumber')
                            }">
                            <div v-show="validationErrors.has('borangbNumber')" class="invalid-feedback">
                                {{ validationErrors.first('borangbNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Borang B/F Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="borangBFFileInput" type="file"  v-validate="''" data-vv-as="Borang B/F Document" name="borangBFFileInput" :class="{'is-invalid':  validationErrors.has('borangBFFileInput')}">
                                    <div v-show="validationErrors.has('borangBFFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('borangBFFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Doctor Malaysian Medical Certificate (MMC) Number</label>
                            <input type="text" name="doctorMmcNumber" data-vv-validate-on="blur" data-vv-as="doctor Malaysian Medical Certificate (MMC) Number"
                                placeholder="Doctor Malaysian Medical Certificate (MMC) Number" v-model="value.doctorMmcNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('doctorMmcNumber')
                            }">
                            <div v-show="validationErrors.has('doctorMmcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('doctorMmcNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Doctor Malaysian Medical Certificate (MMC) Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="doctorMMCFileInput" type="file"  v-validate="''" data-vv-as="Doctor Malaysian Medical Certificate (MMC) Document" name="doctorMMCFileInput" :class="{'is-invalid':  validationErrors.has('doctorMMCFileInput')}">
                                    <div v-show="validationErrors.has('doctorMMCFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('doctorMMCFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Doctor Annual Practitioner Certificate (APC) Number</label>
                            <input type="text" name="doctorApcNumber" data-vv-validate-on="blur" data-vv-as="doctor Annual Practitioner Certificate (APC) Number"
                                placeholder="Doctor Annual Practitioner Certificate (APC) Number" v-model="value.doctorApcNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('doctorApcNumber')
                            }">
                            <div v-show="validationErrors.has('doctorApcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('doctorApcNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Doctor Annual Practitioner Certificate (APC) Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="doctorAPCFileInput" type="file"  v-validate="''" data-vv-as="Doctor Annual Practitioner Certificate (APC) Document" name="doctorAPCFileInput" :class="{'is-invalid':  validationErrors.has('doctorAPCFileInput')}">
                                    <div v-show="validationErrors.has('doctorAPCFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('doctorAPCFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Contact Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Contact Person</label>
                            <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                                placeholder="Contact Person" v-model="value.contactPerson" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPerson')
                            }">
                            <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                                {{ validationErrors.first('contactPerson') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Contact Person Designation</label>
                            <input type="text" name="contactPersonDesignation" data-vv-validate-on="blur" data-vv-as="contact person designation"
                                placeholder="E.g. Mr., Mrs, Dr., Dato Sri" v-model="value.contactPersonDesignation" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPersonDesignation')
                            }">
                            <div v-show="validationErrors.has('contactPersonDesignation')" class="invalid-feedback">
                                {{ validationErrors.first('contactPersonDesignation') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Clinic Phone</label>
                            <input type="text" name="clinicPhone" data-vv-validate-on="blur" data-vv-as="clinic phone"
                                placeholder="Clinic Phone" v-model="value.clinicPhone" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicPhone')
                            }">
                            <div v-show="validationErrors.has('clinicPhone')" class="invalid-feedback">
                                {{ validationErrors.first('clinicPhone') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Clinic Email</label>
                            <input type="text" name="clinicEmail" data-vv-validate-on="blur" data-vv-as="clinic email"
                                placeholder="Clinic Email" v-model="value.clinicEmail" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicEmail')
                            }">
                            <div v-show="validationErrors.has('clinicEmail')" class="invalid-feedback">
                                {{ validationErrors.first('clinicEmail') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Fax (Optional)</label>
                            <input type="text" name="fax" data-vv-validate-on="blur" data-vv-as="fax"
                                placeholder="Fax" v-model="value.fax" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('fax')
                            }">
                            <div v-show="validationErrors.has('fax')" class="invalid-feedback">
                                {{ validationErrors.first('fax') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Website (Optional)</label>
                            <input type="text" name="website" data-vv-validate-on="blur" data-vv-as="website"
                                placeholder="Website" v-model="value.website" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('website')
                            }">
                            <div v-show="validationErrors.has('website')" class="invalid-feedback">
                                {{ validationErrors.first('website') }}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Location Details</b>
                        </div>

                        <div class="place-map">
                            <div class="mb-2">
                                <p>Adjust red marker to desired location.</p>
                                <p class="text-danger">Click "Get Location" to retrieve latitude and longitude.</p>
                            </div>
                            <div class="place-gmaps-wrapper">
                                <div :id="mapId" class="google-map" :style="
                                {
                                    height:`${mapHeight}px`
                                }">
                                </div>
                                <div class="map-search-wrapper">
                                    <div class="input-group">
                                        <input :id="searchBoxId" type="text" class="form-control mr-1" placeholder="Search location"
                                        v-model="currentAddress">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="getGmapLatLng">
                                                Get Location
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="map-edit-cursor"
                                    :style="cursorPosition">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 font-italic font-weight-bold" style="font-size: 14px;">
                                Auto-filled
                            </div>
                            <div class="form-group required col-12 col-md-6">
                                <label>Latitude</label>
                                <input disabled type="text" name="lat" data-vv-validate-on="blur" data-vv-as="latitude"
                                    placeholder="Latitude" v-model="value.lat" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('lat')
                                }">
                                <div v-show="validationErrors.has('lat')" class="invalid-feedback">
                                    {{ validationErrors.first('lat') }}
                                </div>
                            </div>

                            <div class="form-group required col-12 col-md-6">
                                <label>Longitude</label>
                                <input disabled type="text" name="long" data-vv-validate-on="blur" data-vv-as="longitude"
                                    placeholder="Longitude" v-model="value.long" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('long')
                                }">
                                <div v-show="validationErrors.has('long')" class="invalid-feedback">
                                    {{ validationErrors.first('long') }}
                                </div>
                            </div>
                        </div>

                        <div class="font-weight-bold font-italic" style="font-size: 14px; color:red;">
                            Please fill up
                        </div>

                        <div class="form-group required">
                            <label>Address Line 1</label>
                            <input type="text" name="addressLine1" data-vv-validate-on="blur" data-vv-as="address line 1"
                                placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine1')
                            }">
                            <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine1') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Address Line 2</label>
                            <input type="text" name="addressLine2" data-vv-validate-on="blur" data-vv-as="address line 2"
                                placeholder="Address Line 2" v-model="value.addressLine2" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine2')
                            }">
                            <div v-show="validationErrors.has('addressLine2')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine2') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>City</label>
                            <input type="text" name="addressCity" data-vv-validate-on="blur" data-vv-as="address city"
                                placeholder="City" v-model="value.addressCity" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressCity')
                            }">
                            <div v-show="validationErrors.has('addressCity')" class="invalid-feedback">
                                {{ validationErrors.first('addressCity') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>State</label>
                            <input type="text" name="addressState" data-vv-validate-on="blur" data-vv-as="address state"
                                placeholder="State" v-model="value.addressState" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressState')
                            }">
                            <div v-show="validationErrors.has('addressState')" class="invalid-feedback">
                                {{ validationErrors.first('addressState') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Postcode</label>
                            <input type="text" name="addressPoscode" data-vv-validate-on="blur" data-vv-as="address postcode"
                                placeholder="Postcode" v-model="value.addressPoscode" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressPoscode')
                            }">
                            <div v-show="validationErrors.has('addressPoscode')" class="invalid-feedback">
                                {{ validationErrors.first('addressPoscode') }}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Operating Hours</b>
                            <div v-show="workingDaysHasError" class="text-danger">The operationg hours field is required.</div>
                        </div>
                        <input style="opacity:0;" :class="{ 'is-invalid':  workingDaysHasError }">

                        <div class="row mb-3">
                            <template v-for="workingDay in value.workingDays">
                                <div class="form-group d-flex justify-content-between col-12" :key="workingDay.workingDayId">
                                    <div class="">
                                        <input class="mr-2" type="checkbox" :id="workingDay.text" :value="workingDay.workingDayId" v-model="workingDay.selected">
                                        <label :for="workingDay.text">{{ workingDay.text }}</label>
                                    </div>
                                    <div class="">
                                        <vue-timepicker
                                            input-width="100px"
                                            :disabled="workingDay.selected === false"
                                            format="hh:mm A"
                                            v-model="workingDay.startTime"
                                            hide-clear-button
                                            class="ml-2 mr-2"
                                        >
                                        </vue-timepicker>
                                        to
                                        <vue-timepicker
                                            input-width="100px"
                                            :disabled="workingDay.selected === false"
                                            format="hh:mm A"
                                            class="ml-2 mr-2"
                                            v-model="workingDay.endTime"
                                            hide-clear-button
                                        >
                                        </vue-timepicker>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="form-group">
                            <label>Operating Hours Special Remarks (Optional)</label>
                            <div class="mb-1">
                                <small>E.g.: Lunch hours 12pm - 2pm</small>
                            </div>
                            <input type="text" class="form-control" v-model="value.operatingHoursRemarks">
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Facilities & Services</b>
                        </div>

                        <div class="form-group">
                            <div class="row">
                                <div class="col-6" v-for="facilityAndServiceOption in facilitiesAndServicesOptions" :key="facilityAndServiceOption">
                                    <input type="checkbox" :id="facilityAndServiceOption" :value="facilityAndServiceOption" v-model="value.facilitiesAndServices">
                                    <label class="ml-2" :for="facilityAndServiceOption">{{ facilityAndServiceOption }}</label>
                                </div>
                            </div>

                            <div class="form-group mt-2">
                                <label>Others Tests (Please Specify)</label>
                                <input type="text" name="otherFacilitiesAndServices" data-vv-validate-on="blur" data-vv-as="other facilities and services" placeholder="E.g. MRI Scan" v-model="value.otherFacilitiesAndServices" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('otherFacilitiesAndServices')
                                }">
                                <small>Separate by a comma (,)</small>
                                <div v-show="validationErrors.has('otherFacilitiesAndServices')" class="invalid-feedback">
                                    {{ validationErrors.first('otherFacilitiesAndServices') }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Bank Account Details</b>
                        </div>

                        <div class="form-group">
                            <label>Bank Account Payee Name</label>
                            <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank account payee name"
                                placeholder="Bank Account Payee Name" v-model="value.bankAccountPayeeName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountPayeeName')
                            }">
                            <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountPayeeName') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Bank Name</label>
                            <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                                placeholder="Bank Name" v-model="value.bankName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankName')
                            }">
                            <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                                {{ validationErrors.first('bankName') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Bank Account Number</label>
                            <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                                placeholder="Bank Account Number" v-model="value.bankAccountNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountNumber')
                            }">
                            <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountNumber') }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="card mb-3">
                    <div class="card-header">
                        E-Wallet Facility Application
                    </div>
                    <div class="card-body">
                        <p>Do you want to apply for e-wallet solution?</p>

                        <p>
                            Text to highlight to clinic admins why they should have e-wallet facility and why they should apply through Health Savvy...
                        </p>

                        <div class="mb-3">
                            <div>
                                <a
                                    href="/static/docs/e-wallet-solution.pdf"
                                    target="_blank"
                                    >Click Here to Read More</a
                                >
                            </div>
                            <div>
                                <a
                                    href="/static/docs/e-wallet-solution.pdf"
                                    target="_blank"
                                    >Click Here to View Retail Fees</a
                                >
                            </div>
                            <div>
                                <a
                                    href="/static/docs/e-wallet-solution.pdf"
                                    target="_blank"
                                    >Click Here to Download Application Form</a
                                >
                            </div>
                        </div>

                        <div class="mb-2">
                            <div class="form-check">
                                <label class="form-check-label d-flex">
                                    <input class="form-check-input" type="checkbox" v-model="value.applyForEwallet">
                                    <div class="ml-2" style="margin-top:-3px">I would like to apply for E-Wallet facility.</div>
                                </label>
                            </div>
                        </div>

                        <div v-if="value.applyForEwallet">
                            <div>
                                <p>
                                    Upload Application Form
                                </p>
                                <div>
                                    <input
                                        id="uploadApplicationFileInput"
                                        type="file"
                                        v-validate="value.applyForEwallet ? 'required' : ''"
                                        data-vv-as="application form file"
                                        name="applicationForm"
                                        :class="{
                                            'is-invalid': validationErrors.has(
                                                'applicationForm'
                                            ),
                                        }"
                                    />
                                    <div
                                        v-show="
                                            validationErrors.has('applicationForm')
                                        "
                                        class="invalid-feedback"
                                    >
                                        {{
                                            validationErrors.first(
                                                "applicationForm"
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </form>
    </div>
</template>

<script>
/* global google */
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
import multipleSelectDropdown from '@/components/multiple-select-dropdown';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import facilitiesAndServicesOptions from '@/config/facilitiesAndServices';
import languages from '@/config/languages';
import {
    mask
} from 'vue-the-mask';

export default {
    'name': 'RegisterClinicComponent',
    'components': {
        multipleSelectDropdown,
        VueTimepicker
    },
    'directives': {
        mask
    },
    'props': {
        'value': Object
    },
    'computed': {
        mapHeight () {
            return this.mapWidth;
        },
        cursorPosition () {
            let cursorWidth = 48;
            let tipOffset = 20;

            return {
                'left': `${(this.mapHeight / 2) - (cursorWidth / 2)}px`,
                'top': `${((this.mapHeight / 2) - (cursorWidth / 2)) - tipOffset}px`
            };
        }
    },
    data () {
        return {
            facilitiesAndServicesOptions,
            languages,
            'mapId': '',
            'mapDom': null,
            'searchBoxId': '',
            'searchBoxDom': null,
            'googleMapObj': null,
            'googleMapsAutoComplete': null,
            'currentAddress': '',
            'mapWidth': '',
            'workingDaysHasError': false,
            'languagesSpeakHasError': false
        };
    },
    'watch': {
        mapHeight () {
            this.$nextTick(() => {
                this.googleMapsResizeHandler();
            });
        }
    },
    'methods': {
        validate () {
            let workingDayCount = 7;

            for (const workingDay of this.value.workingDays) {
                if (workingDay.selected === false) {
                    workingDayCount--;
                }
            }

            if (workingDayCount <= 0) {
                this.workingDaysHasError = true;
                return Promise.resolve(false);
            }

            if (this.value.languagesSpeak.length === 0) {
                this.languagesSpeakHasError = true;
                return Promise.resolve(false);
            } else {
                this.languagesSpeakHasError = false;
            }

            return this.$validator.validateAll();
        },
        updateWorkingDays (selectedValue) {
            // find index of selectedItem
            let selectedIndex = this.value.workingDays.findIndex((s) => s === selectedValue);

            if (selectedIndex > -1) {
                this.value.workingDays.splice(selectedIndex, 1);
            } else {
                this.value.workingDays.push(selectedValue);
            }

            this.value.workingDays.sort((a, b) => (a.DayId > b.DayId) ? 1 : ((b.DayId > a.DayId) ? -1 : 0));
        },
        getDayText (DayId) {
            const workingDay = this.workingDays.find(workingDay => workingDay.value.DayId === DayId);

            return workingDay.text;
        },
        initGoogleMaps () {
            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);

            // Init search box, restrict places to Malaysia only.
            this.googleMapsAutoComplete = new google.maps.places.Autocomplete(this.searchBoxDOM);
            this.googleMapsAutoComplete.setComponentRestrictions({ 'country': 'my' });

            this.googleMapsAutoComplete.addListener('place_changed', () => {
                let place = this.googleMapsAutoComplete.getPlace();
                let placeGeometry = place.geometry;

                // this.form.searchLocation = place.name;
                if (placeGeometry) {
                    this.googleMapObj.setCenter(placeGeometry.location);
                }
            });

            this.googleMapObj.addListener('click', (event) => {
                this.googleMapObj.setCenter(event.latLng);
            });

            // Bias the SearchBox results towards current map's viewport.
            this.googleMapObj.addListener('bounds_changed', () => {
                this.googleMapsAutoComplete.setBounds(this.googleMapObj.getBounds());
            });
        },
        googleMapsResizeHandler () {
            if (this.googleMapObj) {
                google.maps.event.trigger(this.googleMapObj, 'resize');
            }
        },
        windowResizeHandler () {
            this.mapWidth = this.mapDOM.getBoundingClientRect().width;
        },
        getGmapLatLng () {
            if (this.googleMapObj) {
                let latLng = this.googleMapObj.getCenter();
                this.value.lat = latLng.lat();
                this.value.long = latLng.lng();
            }
        }
    },
    created () {
        this.mapId = generateRandomId();
        this.searchBoxId = generateRandomId();
    },
    mounted () {
        window.addEventListener('resize', this.windowResizeHandler);
        window.addEventListener('orientationchange', this.windowResizeHandler);

        this.mapDOM = document.getElementById(this.mapId);
        this.searchBoxDOM = document.getElementById(this.searchBoxId);
        this.mapWidth = this.mapDOM.getBoundingClientRect().width;

        this.initGoogleMaps();
    },
    destroyed () {
        window.removeEventListener('resize', this.windowResizeHandler);
        window.removeEventListener('orientationchange', this.windowResizeHandler);
    }
};
</script>

<style scoped>
/*Place Detail*/
.place-map
{
    margin-bottom: 1rem;
}

.place-map > .place-gmaps-wrapper {
    position: relative;
}

.place-map .map-search-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 1em 1em 0 1em;
}

.place-map .map-edit-cursor {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    background-image: url("../../assets/img/icons/location_edit.svg");
    background-size: 48px 48px;
    background-position: top left;
    background-repeat: no-repeat;
}

/* .place-map  .map-no-edit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */
/*Place Detail*/
</style>
